export default {"src":"/_next/static/media/locked.607d9ec6.svg","height":110,"width":100};